import AcknowledgmentRecord from "models/view-models/acknowledgment-record";
import ServiceFactory from "../service-factory";

const baseEndpoint = "acknowledgments";

export const AcknowledgmentService = {
    create: ServiceFactory.create(AcknowledgmentRecord, baseEndpoint),
};
